import React from 'react';
import { useIntl } from 'react-intl';

import Button from 'carbon-react/lib/components/button';
import Link from 'carbon-react/lib/components/link';
import Textarea from 'carbon-react/lib/components/textarea';
import Typography from 'carbon-react/lib/components/typography';

import styles from './ai-prediction-chat.scss';

const DEFAULT_PRIVACY_URL = 'https://www.sage.com/en-gb/legal/privacy/';

export const AIPredictionChat = () => {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'predict.forecasts.ai_prediction_chat.title',
    defaultMessage: 'Sage Copilot'
  });

  return (
    <section className={styles.chat} aria-label={title}>
      <header className={styles.header}>
        <Typography color="white" fontSize="18px" fontWeight="600" mb={0}>
          {title}
        </Typography>
      </header>

      <div className={styles.conversation} />

      <div className={styles.composer}>
        <div className={styles.inputContainer}>
          <Textarea
            label={intl.formatMessage({
              id: 'predict.forecasts.ai_prediction_chat.prompt_label',
              defaultMessage: 'Ask Copilot a question'
            })}
            placeholder={intl.formatMessage({
              id: 'predict.forecasts.ai_prediction_chat.placeholder',
              defaultMessage: 'Ask for a change or describe another formula...'
            })}
            value=""
            onChange={() => undefined}
            rows={3}
            resize="none"
            style={{ paddingRight: '68px' }}
            mb={0}
          />
          <Button
            className={styles.sendButton}
            aria-label={intl.formatMessage({
              id: 'predict.forecasts.ai_prediction_chat.send',
              defaultMessage: 'Send message'
            })}
            buttonType="primary"
            iconType="send"
            type="button"
          />
        </div>

        <div className={styles.disclaimer}>
          <Typography className={styles.disclaimerText} fontSize="14px" color="#626a6e" mb={0}>
            {intl.formatMessage({
              id: 'predict.forecasts.ai_prediction_chat.disclaimer',
              defaultMessage: 'Check AI content for inaccuracies.'
            })}
          </Typography>
          <Link
            className={styles.privacyLink}
            href={DEFAULT_PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            icon="link"
            iconAlign="right"
            underline="always"
            linkSize="medium"
          >
            {intl.formatMessage({
              id: 'predict.forecasts.ai_prediction_chat.privacy_notice',
              defaultMessage: 'Privacy notice'
            })}
          </Link>
        </div>
      </div>
    </section>
  );
};
